import React from 'react';
import { DocPageLayout } from '../../components/DocPageLayout';
import { CodeBlock } from '../../components/CodeBlock';
import { InfoBox } from '../../components/InfoBox';
interface CheckoutSubsequentOpsPageProps {
  onNavigate?: (pageId: string) => void;
}
export function CheckoutSubsequentOpsPage({
  onNavigate
}: CheckoutSubsequentOpsPageProps) {
  return <DocPageLayout title="Subsequent Operations" data-id="element-1442">
      <div className="text-sm text-gray-500 mb-6 -mt-8" data-id="element-1443">
        <button onClick={() => onNavigate?.('overview')} className="hover:underline text-orange-600" data-id="element-1444">
          Overview
        </button>{' '}
        &gt;{' '}
        <button onClick={() => onNavigate?.('checkout')} className="hover:underline text-orange-600" data-id="element-1445">
          &lt;&lt;checkout&gt;&gt;
        </button>{' '}
        &gt; Subsequent Operations
      </div>

      <p className="text-gray-700 mb-6" data-id="element-1446">
        After a successful initial transaction, you may need to perform
        subsequent operations such as capturing an authorization, refunding a
        payment, or voiding a transaction. These operations are performed via
        server-to-server API calls and do not require payer participation.
      </p>

      <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1447">Capture</h2>
      <p className="text-gray-700 mb-4" data-id="element-1448">
        If the initial transaction was an AUTHORIZE, you must capture the funds
        to complete the transfer.
      </p>
      <CodeBlock language="JSON" title="Capture Request" code={`{
  "apiOperation": "CAPTURE",
  "transaction": {
    "amount": "100.00",
    "currency": "USD"
  }
}`} data-id="element-1449" />

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1450">Refund</h2>
      <p className="text-gray-700 mb-4" data-id="element-1451">
        Return funds to the payer for a previously captured transaction. Refunds
        can be full or partial.
      </p>
      <CodeBlock language="JSON" title="Refund Request" code={`{
  "apiOperation": "REFUND",
  "transaction": {
    "amount": "50.00",
    "currency": "USD"
  }
}`} data-id="element-1452" />

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1453">Void</h2>
      <p className="text-gray-700 mb-4" data-id="element-1454">
        Cancel an authorized transaction before it has been captured. This
        releases the hold on the payer's funds.
      </p>
      <CodeBlock language="JSON" title="Void Request" code={`{
  "apiOperation": "VOID",
  "transaction": {
    "targetTransactionId": "TXN-001"
  }
}`} data-id="element-1455" />

      <InfoBox type="info" title="Timing" data-id="element-1456">
        Void operations must be performed before the transaction is captured or
        settled. After settlement, use a refund instead.
      </InfoBox>
    </DocPageLayout>;
}